// Lib
import { EditorState, Modifier } from 'draft-js';

// Utils
import commonMarkdownHandlerReturn from './commonMarkdownHandlerReturn';
import createHandleCharacterFn from './createHandleCharacterFn';

// Constants
import { EditorChangeType } from '../../draftjsConstants';

export default ({ enableBlockStyles }) => {
    const handleCharacter = createHandleCharacterFn({ enableBlockStyles });

    return (ev, editorState, { setEditorState }) => {
        let newEditorState = handleCharacter(editorState, '');

        // If we have handled some markdown, then insert the new line manually here as
        // it won't be handled by the default 'split-block' command handler
        if (editorState !== newEditorState) {
            const newContentState = Modifier.splitBlock(
                newEditorState.getCurrentContent(),
                newEditorState.getSelection(),
            );
            newEditorState = EditorState.push(newEditorState, newContentState, EditorChangeType.SPLIT_BLOCK);
        }

        return commonMarkdownHandlerReturn(editorState, newEditorState, { setEditorState });
    };
};
